import { configureStore } from "@reduxjs/toolkit";
import jobs from "./slices/jobsSlice";
import countries from "./slices/countriesSlice";
import settings from "./slices/settingsSlice";
import news from "./slices/newsSlice";
import partners from "./slices/partnersSlice";
import certificates from "./slices/certificatesSlice";
import projects from "./slices/projectsSlice";
import branches from "./slices/branchesSlice";

export const contractingStore = configureStore({
  reducer: {
    jobs,
    countries,
    settings,
    news,
    partners,
    certificates,
    projects,
    branches,
  },
});

export const equipmentsStore = configureStore({
  reducer: {
    jobs,
    countries,
    settings,
    news,
    partners,
    certificates,
    projects,
    branches,
  },
});

export const publicStore = configureStore({
  reducer: {
    jobs,
    countries,
    settings,
  },
});

export type RootState = ReturnType<typeof contractingStore.getState>;
export type AppDispatch = typeof contractingStore.dispatch;
